import React, { useEffect, useState, Fragment } from 'react'
import { base_url } from '../Api/Api';
import Skeletoncnt from '../Education/skeletonContent';

const AboutUs = () => {

    const [source, setSource] = useState('')

    useEffect(() => {

        base_url.get(`staticPages`)
            .then(response => {
                setSource(response.data.about_us)
            })
    }, [])

    return (
        <div className="contain">
            {source.length == 0 ?
                <Fragment>
                    <Skeletoncnt />
                    <Skeletoncnt />
                </Fragment>
                :
                <div
                    className="static-pages_source"
                    dangerouslySetInnerHTML={{ __html: source }}></div>
            }
        </div>
    );
}

export default AboutUs;